module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/flashcards_icon-886c25e720a5cd2ead57f7809bf07f88.png";